export default __webpack_public_path__ + "static/media/atome-logo.00c51526.svg";